import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import { ContextualSurvey as AkContextualSurvey, DismissTrigger } from '@atlaskit/contextual-survey';
var flagKey = 'atlassian_research_group_mailinglist_actioned';

// eslint-disable-next-line @repo/internal/react/no-class-components
var ContextualSurvey = /*#__PURE__*/function (_PureComponent) {
  _inherits(ContextualSurvey, _PureComponent);
  var _super = _createSuper(ContextualSurvey);
  function ContextualSurvey() {
    var _this;
    _classCallCheck(this, ContextualSurvey);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onDismiss", function (onDismissArgs) {
      var _this$props = _this.props,
        cloudId = _this$props.cloudId,
        messageId = _this$props.messageId,
        fireClickEvent = _this$props.fireClickEvent,
        stargateUrl = _this$props.stargateUrl,
        markAsSeenAndFatigued = _this$props.markAsSeenAndFatigued,
        orgId = _this$props.orgId,
        workspaceId = _this$props.workspaceId;
      if (onDismissArgs.trigger === DismissTrigger.Manual) {
        markAsSeenAndFatigued({
          stargateUrl: stargateUrl,
          cloudId: cloudId,
          messageId: messageId,
          orgId: orgId,
          workspaceId: workspaceId
        });
      }
      fireClickEvent('dismiss');
    });
    _defineProperty(_assertThisInitialized(_this), "getUserHasAnsweredMailingList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props2, stargateUrl, aaid, cloudId, getFlag;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props2 = _this.props, stargateUrl = _this$props2.stargateUrl, aaid = _this$props2.aaid, cloudId = _this$props2.cloudId, getFlag = _this$props2.getFlag;
            _context.prev = 1;
            _context.next = 4;
            return getFlag(stargateUrl, cloudId, flagKey, aaid);
          case 4:
            return _context.abrupt("return", Promise.resolve(false));
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", Promise.resolve(true));
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formValues) {
        var _this$props3, cloudId, messageId, question, statement, stargateUrl, markAsSeenAndFatigued, sendUserResponse, orgId, workspaceId, canContact, feedbackScore, writtenFeedback, payload;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props3 = _this.props, cloudId = _this$props3.cloudId, messageId = _this$props3.messageId, question = _this$props3.question, statement = _this$props3.statement, stargateUrl = _this$props3.stargateUrl, markAsSeenAndFatigued = _this$props3.markAsSeenAndFatigued, sendUserResponse = _this$props3.sendUserResponse, orgId = _this$props3.orgId, workspaceId = _this$props3.workspaceId;
              canContact = formValues.canContact, feedbackScore = formValues.feedbackScore, writtenFeedback = formValues.writtenFeedback;
              payload = {
                responseType: 'ACCEPTANCE_SURVEY',
                properties: {
                  surveyTimestamp: Date.now(),
                  contextualQuestion: question,
                  contextualStatement: statement,
                  quantitativeResponse: feedbackScore,
                  qualitativeResponse: writtenFeedback,
                  contactable: canContact
                }
              };
              markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
              });
              _this.firePrimaryClickEvent();

              // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
              return _context2.abrupt("return", sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(function () {
                return Promise.resolve();
              }));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onMailingListAnswer", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(answer) {
        var _this$props4, aaid, cloudId, stargateUrl, messageId, sendUserResponse, setFlag, payload;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this$props4 = _this.props, aaid = _this$props4.aaid, cloudId = _this$props4.cloudId, stargateUrl = _this$props4.stargateUrl, messageId = _this$props4.messageId, sendUserResponse = _this$props4.sendUserResponse, setFlag = _this$props4.setFlag;
              payload = {
                responseType: 'MAILING_LIST_RESPONSE',
                properties: {}
              };
              setFlag(stargateUrl, cloudId, flagKey, aaid);
              if (answer) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              return _context3.abrupt("return", sendUserResponse(cloudId, stargateUrl, messageId, payload));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    return _this;
  }
  _createClass(ContextualSurvey, [{
    key: "firePrimaryClickEvent",
    value: function firePrimaryClickEvent() {
      this.props.fireClickEvent('primary');
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AkContextualSurvey, _extends({
        onDismiss: this.onDismiss,
        getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
        onMailingListAnswer: this.onMailingListAnswer,
        onSubmit: this.onSubmit
      }, this.props));
    }
  }]);
  return ContextualSurvey;
}(PureComponent);
export { ContextualSurvey as default };